import { Location } from '@angular/common';
import { Component, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material';
import { ActivatedRoute, Router, Scroll } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { DocumentTypeEnterprise } from 'src/app/core/class/DocumentTypeEnterprise';
import { Message } from 'src/app/core/class/message';
import { LotType } from 'src/app/core/constants/lot-type';
import { CommonService } from 'src/app/core/services/common.service';
import { DataService } from 'src/app/core/services/data.service';
import { DocumentTemplateService } from 'src/app/core/services/document-template.service';
import { DocumentTypeService } from 'src/app/core/services/document-type.service';
import { ContentType } from 'src/app/core/services/file-utils';
import { ImportLotService } from 'src/app/core/services/import-lot.service';
import { NotificationService } from 'src/app/core/services/notification.service';
import { ProcessingService } from 'src/app/core/services/processing.service';
import { TemplateFileService } from 'src/app/core/services/template-file.service';
import { UploadFileComponent } from 'src/app/shared/components/upload-file/upload-file.component';
import { ContractLotService } from "src/app/core/services/contract-lot.service";
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import {BreadcrumbsService} from 'src/app/shared/components/breadcrumbs/breadcrumbs.service';
@Component({
  selector: 'app-add-user-by-file',
  templateUrl: './add-user-by-file.component.html',
  styleUrls: ['./add-user-by-file.component.scss']
})
export class AddUserByFileComponent implements OnInit, OnDestroy {
  @ViewChild(UploadFileComponent, { read: UploadFileComponent, static: false }) uploadFileComponent;
  viewMode: 'create' | 'view' = 'create';
  templateFile: any = null;
  name: string = null;
  processing: any = null;
  @BlockUI() blockUI: NgBlockUI;
  @HostListener('window:scroll', ['$event']) onKeydownHandler(event: Scroll) {
    this.onTableScroll();
  }
  errorFile: boolean = false;
  lastScrollTop = 0;
  subcription: Subscription = new Subscription();
  isShowStep = false;
  current = 0;
  fileName: string = "";
  fileBase64: string = "";
  documentTypeEnterprise: DocumentTypeEnterprise;
  serviceType: any;
  public templateId: number;
  createSide: any = null;
  dataFootNote: any = null;
  private subscribeHaveFileUpload: any;
  private subscribeHaveErrorResult: any;
  haveFileUpload = false;
  haveErrorResult = false;
  currentTab: number = 0;
  private subscribeDownFile: any;
  id: string = null;
  bread
  errorFormatTypeFile = false;
  start: number = 0;
  limit: number = 15;
  end: number = this.limit + this.start;
  acceptContentType: ContentType[] = [ContentType.UNKNOWN];
  isLoading = false
  resultImportExcelName: any;
  fileCode: any
  dataUploadFile: any;
  fileUpload: any[] = [];
  nzData: any[] = [];
  dataSource: any[] = [];
  isUser: boolean = true;
  pollingInterval: any = null;
  constructor(private templateFileService: TemplateFileService,
    public commonService: CommonService,
    private dialog: MatDialog,
    private router: Router,
    public notificationService: NotificationService,
    private toast: ToastrService,
    public message: Message,
    private route: ActivatedRoute,
    private documentTypeService: DocumentTypeService,
    public documentTemplateService: DocumentTemplateService,
    public location: Location,
    private breadcrumbsService: BreadcrumbsService,
    public processingService: ProcessingService,
    private dataService: DataService,
    public importLotService: ImportLotService,
    public contractLotService: ContractLotService,
    private toastr: ToastrService,) {
    if (this.router.url.includes('import-customer')) {
      this.isUser = false
    }

    this.bread = this.isUser ? {label: 'breadcrumbs.enterprise_user', url: 'user', params: []} : {label: 'breadcrumbs.enterprise_customer', url: 'customers', params: []};
  }

  identify(index, item){
    return item.status;
  }

  handleBreadcrumbs() {

    this.breadcrumbsService.store([
      {label: 'breadcrumbs.home', url: 'analysis-report', params: []},
      {label: 'breadcrumbs.enterprise_manage', params: []},
      this.bread,
      {
        label: this.message.getMessage("breadcrumbs.import_file")
      },
    ]);
  }

  ngOnInit() {
    this.id = this.route.snapshot.params.id;
    this.handleBreadcrumbs();
    if (this.id) {
      this.viewMode = 'view';

      // =====================================================================
      // NÂNG CẤP: Websocket bị die nên COMMENT khối theo dõi realtime qua
      // processingService.recordSocketQueue / processingService.processingTask.
      // Thay thế bằng polling gọi API /import-lot/get-by-id/{id} mỗi 5 giây.
      // =====================================================================
      // const importType = this.isUser ? LotType.USER_LOT : LotType.CUSTOMER_LOT
      //
      // /**
      //  * Subscibe data queue emit from websocket
      //  */
      // const readRecordTaskSub = this.processingService.recordSocketQueue.subscribe(record => {
      //   try {
      //     this.dataSource = this.dataSource.map(el => {
      //       if(this.decodeId(el.id) == this.decodeId(record.idEncrypt)) {
      //         el.status = record.status
      //         el.errorMessage = record.errorMessage
      //         return el;
      //       } else return el;
      //     })
      //   } catch (e) {
      //     console.log(`🚀`,e)
      //   }
      // })
      //
      // const proccesingTaskSub = this.processingService.processingTask.subscribe(ref => {
      //   const process = ref.find(item => item.id.replace(/\=/g, '') === this.id.replace(/\=/g, '') && item.type === importType);
      //   if (process) {
      //     this.importLotService.getImportLotById(this.id).subscribe(res => {
      //       if (!res || !res.data.lotDetails) {
      //         return;
      //       }
      //       this.dataSource = res.data.lotDetails;
      //       this.limit = res.data.lotDetails.length;
      //       this.end = this.limit + this.start;
      //       this.nzData = this.getTableData(this.start, this.end);
      //       this.fileCode = res.data.code;
      //       this.fileName = res.data.importFileName;
      //     })
      //     this.processing = process;
      //   } else if (this.processing) {
      //     this.importLotService.getImportLotById(this.id).subscribe(res => {
      //       if (!res || !res.data.lotDetails) {
      //         return;
      //       }
      //       this.dataSource = res.data.lotDetails;
      //       this.limit = res.data.lotDetails.length;
      //       this.end = this.limit + this.start;
      //       this.nzData = this.getTableData(this.start, this.end);
      //       this.fileCode = res.data.code;
      //       this.fileName = res.data.importFileName;
      //     });
      //     if(this.processing.percent == 100)
      //       this.processing = null;
      //   }
      // });
      // this.subcription.add(proccesingTaskSub);
      // this.subcription.add(readRecordTaskSub);

      // Gọi API lấy kết quả lần đầu
      this.refreshImportResult();
      // Polling gọi API /import-lot/get-by-id/{id} mỗi 3 giây thay cho websocket
      this.pollingInterval = setInterval(() => {
        this.refreshImportResult();
      }, 3000);
    }

  }

  /**
   * Gọi API /import-lot/get-by-id/{id} để lấy danh sách kết quả import theo lô.
   * Được gọi mỗi 5 giây (polling) thay cho websocket.
   */
  refreshImportResult() {
    this.importLotService.getImportLotById(this.id).subscribe(res => {
      if (!res || !res.data.lotDetails) {
        return;
      }
      this.dataSource = res.data.lotDetails;
      this.limit = res.data.lotDetails.length;
      this.end = this.limit + this.start;
      this.nzData = this.getTableData(this.start, this.end);
      this.fileCode = res.data.code;
      this.fileName = res.data.importFileName;

      // Cập nhật % tiến trình cho progress bar (hiển thị qua processing.percent)
      const percent = this.renderPercent();
      if (percent >= 100) {
        this.processing = null;
        this.stopPolling();
      } else {
        this.processing = { percent };
      }
    });
  }

  stopPolling() {
    if (this.pollingInterval) {
      clearInterval(this.pollingInterval);
      this.pollingInterval = null;
    }
  }

  ngOnDestroy() {
    this.stopPolling();
    this.subcription.unsubscribe();
  }

  decodeId(id: string) {
    const idDecode = atob(id);
    const findNumber = idDecode.match(/[0-9]{1,}/g);
    if (findNumber && findNumber.length) {
      return Number(findNumber[findNumber.length - 1]);
    }
    return null;
  }

  onTableScroll() {
    let st = window.pageYOffset || document.documentElement.scrollTop;

    // If the user has scrolled within 200px of the bottom, add more data
    const buffer = 200;
    const limit = st - buffer;
    if (limit > this.lastScrollTop || this.lastScrollTop === 0) {
      this.nzData = this.getTableData(this.start, this.end);
      this.updateIndex();
      this.lastScrollTop = limit <= 0 ? 0 : limit;
    }
  }

  getTableData(start, end) {
    return this.dataSource.filter((value, index) => index < end);
  }

  updateIndex() {
    this.end = this.limit + this.end;
  }

  // preview() {
  //   this.templateFileService.getContentTemplateFileByUrl({
  //     type: 'TEMPLATE_PDF',
  //     url: this.templateFile.file.pdfUrl
  //   }).subscribe(rs => {
  //     if (!rs) {
  //       return;
  //     }
  //     this.dialog.open(DialogPreviewPdfComponent, {
  //       width: '80%',
  //       data: {
  //         file: rs,
  //         name: this.name,
  //       },
  //     });
  //   })
  // }

  renderNumber(type: 'total' | 'success' | 'error') {
    if (this.dataSource) {
      switch (type) {
        case 'total':
          return this.dataSource.length;
        case 'error':
          return this.dataSource.filter(item => {
            return item.status === 'ERROR' || item.status === 'UPDATE_ERROR';
          }).length;
        case 'success':
          return this.dataSource.filter(item => {
            return item.status === 'DONE' || item.status === 'UPDATE_DONE';
          }).length;
      }
    }
  }

  renderPercent() {
    let percent = Math.round((this.renderNumber("error") + this.renderNumber("success")) / this.renderNumber("total") * 100);
    return percent ? percent : 0;
  }

  randomStr(length) {
    const characters = '0123456789';
    let result = '';
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() *
        charactersLength));
    }
    return result;
  }

  renderStatus(status: string) {
    switch (status) {
      case 'ERROR':
        return this.message.getMessage('import_file.status.error');
      case 'PROCESSING':
        return this.message.getMessage('import_file.status.processing');
      case 'DONE':
        return this.message.getMessage('import_file.status.done');
      case 'UPDATE_DONE':
        return this.message.getMessage('timestamp.title.update_success');
      case 'UPDATE_ERROR':
        return this.message.getMessage('brand_name.updated_fail');
      default:
        return '';
    }
  }

  renderStatusColor(status: string): object {
    switch (status) {
      case 'ERROR':
        return { 'color': 'red', 'border': '1px solid red', 'border-radius': '5px' };
      case 'PROCESSING':
        return { 'color': 'blue', 'border': '1px solid blue', 'border-radius': '5px' };
      case 'UPDATE_ERROR':
        return { 'color': 'red', 'border': '1px solid red', 'border-radius': '5px' };
      case 'UPDATE_DONE':
        return { 'color': 'green', 'border': '1px solid green', 'border-radius': '5px' };
      default:
        return { 'color': 'green', 'border': '1px solid green', 'border-radius': '5px' };
    }
  }

  getResultFile() {
    this.importLotService.getResultFile(this.id).subscribe(res => {
      this.downLoadFile(res, 'application/octet-stream', this.fileCode ? this.fileCode + '_ketqua.xlsx' : 'ketqua.xlsx');
    })
  }

  uploadFile() {
    const inputFile = document.getElementById("file");
    inputFile.click();
  }

  async onChangeFile(event: any) {
    this.fileUpload = []
    const temp = (<HTMLInputElement>document.getElementById("file")).files[0];
    this.fileUpload.push(temp)
    console.log(this.fileUpload);

    const accept: RegExp = /(\.xlsx)$/;
    if (!accept.exec(temp.name)) {
      this.toast.error(
        this.message.getMessage("messages.error_file_type_excel")
      );
      return;
    }
    if (temp.size > 2000000) {
      this.toast.error(this.message.getMessage("messages.error_import_file_size"));
      return;
    }
    this.fileName = temp.name;
    this.fileBase64 = await this.getBase64(temp) as any;
  }

  deleteFile() {
    this.fileName = null;
    this.fileBase64 = null;
  }

  getBase64(file) {
    return new Promise((resolve, reject) => {
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  }

  downloadFileTemplate() {
    // this.contractLotService.generateImportFile({ documentTypeEnterpriseId: this.documentTypeEnterprise.id }).subscribe(res => {
    //   this.downLoadFile(res, 'application/octet-stream', this.documentTypeEnterprise.name + '.xlsx');
    // })
  }

  downLoadFile(data: any, type: string, fileName: string) {
    const blob = new Blob([data], { type });
    if (window.top.navigator.msSaveOrOpenBlob) {
      // Store Blob in IE
      window.top.navigator.msSaveOrOpenBlob(blob, fileName);
    } else {
      // Store Blob in others
      const tA = document.body.appendChild(document.createElement('a'));
      tA.href = URL.createObjectURL(blob);
      tA.download = fileName;
      tA.style.display = 'none';
      tA.click();
      tA.parentNode.removeChild(tA);
    }
  }

  onClickCancel() {
    // if (this.fileName) {
    //   const confirmDialog = this.dialog.open(WarningComponent, {
    //     width: '40%',
    //     data: this.message.getMessage('messages.cancel_create_contract_lot')
    //   });
    //   confirmDialog.afterClosed().subscribe(ref => {
    //     if (ref) {
    //       this.location.back();
    //     }
    //   });
    //   return;
    // }
    this.location.back();
  }

  submit() {
    this.errorFile = false;
    if (!this.fileBase64) {
      this.toast.error(this.message.getMessage('validation.error_not_have_file_lot'));
      return;
    }
    this.blockUI.start('');
    this.fileBase64 = this.fileBase64.replace('data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,', '');
    if (this.isUser) {
      this.uploadUser(this.fileUpload);
    } else {
      this.uploadCustomer(this.fileUpload);
    }

  }

  onUploadFileUser() {
    this.uploadFileComponent.uploadFile();
  }

  downFileTemplateExcelAddUser(e, isNew = false) {
    if (this.isUser) {
      this.commonService.downFileTemplateExcelAddUser().subscribe(rs => {
        this.downLoadFile(rs, 'application/octet-stream', 'Template_import_user.xlsx');
      })
    } else {
      if(isNew){
        this.commonService.downFileTemplateExcelAddCustomer('?isNewAddress=true').subscribe(rs => {
          this.downLoadFile(rs, 'application/octet-stream', 'Template_import_customer.xlsx');
        })
      } else {
        this.commonService.downFileTemplateExcelAddCustomer().subscribe(rs => {
          this.downLoadFile(rs, 'application/octet-stream', 'Template_import_customer.xlsx');
        })
      }
    }
  }

  uploadUser(fileUpload: any) {
    this.importLotService.importFromExcel(fileUpload, LotType.USER_LOT)
      .subscribe(rs => {
        if (rs && rs.success) {
          this.contractLotService.processingStart.next(true);
          this.blockUI.stop();
          this.router.navigateByUrl(`/home-enterprise/import-user/${rs.data}`);
        } else if (!rs.success) {
          this.blockUI.stop();
          this.toastr.error(rs.message);
        }
      });
  }

  uploadCustomer(fileUpload: any) {
    this.importLotService.importFromExcel(fileUpload, LotType.CUSTOMER_LOT)
      .subscribe(rs => {
        if (rs && rs.success) {
          this.contractLotService.processingStart.next(true);
          this.blockUI.stop();
          this.router.navigateByUrl(`/home-enterprise/import-customer/${rs.data}`);
        } else if (!rs.success) {
          this.blockUI.stop();
          this.toastr.error(rs.message);
        }
      });
  }
  dateToString(date: Date) {
    const dd = String(date.getDate()).padStart(2, '0');
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const yyyy = date.getFullYear();
    let hour = String(date.getHours()).padStart(2, '0');
    let minutes = String(date.getMinutes()).padStart(2, '0');
    let seconds = String(date.getSeconds()).padStart(2, '0');
    return yyyy + mm + dd + hour + minutes + seconds;
  }

}
